import { toggles } from "../../../environments/environment";
import { LocalStorage } from "./local-storage";

export class TogglesValidation {
  static toggleShow(key: string) {
    try {
      const toggleParamerns = key;
      const emailLogado = LocalStorage.getItem("currentUser")?.email;
      const toggle = toggles.find(f => {
        return f.key === toggleParamerns;
      });
      return toggle.activated || toggle.emails.includes(emailLogado);
    } catch (error) {
      return false;
    }
  }
}
